<template>
    <div class="importCluesBox">
        <div class="title">
            <p></p>
            <h4>批量导入线索</h4>
        </div>
        <el-button type="primary" @click="downloadFile">下载模板</el-button>

        <el-upload
            class="upload-demo"
            :limit="1"
            :on-success="handleSuccess"
            accept=".xlsx,.xls"
            :headers="headers"
            :action="url"
            :on-exceed="handleExceed"
            name="file">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">请先在下载的Excel模板中添加数据，然后点击此处导入填好的Excel</div>
        </el-upload>
    </div>
</template>

<script>
import { getCluesTemplate } from '@/api/callCenter';

export default {
    name: 'importClues',
    data(){
        return{
            url:process.env.VUE_APP_BASE_API+'/api/customer_clue_batch_import',
            headers: {
                'Authorization': sessionStorage.getItem('token'),
                'Comid': sessionStorage.getItem('shenfen'),
                "Platformsn":JSON.parse(localStorage.getItem('userData')).platform_sn
            }
        }
    },
    methods:{
        // 下载模板
        downloadFile(){
            getCluesTemplate().then(res=>{
                if (res.code == 200) {
                    const link = document.createElement('a'); //自己创建的a标签
                    link.href = res.data.download_url;
                    link.target = '_blank';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(res.data.download_url);
                }
            })
        },
        // 上传成功
        handleSuccess(response, file, fileList) {
            if (response.code == 200) {
                this.$message.success(response.msg);
                this.$router.push('/clueList');
            }else {
                this.$message.error(response.msg);
            }
        },
        // 上传文件数量超出限制
        handleExceed(files, fileList) {
            if (fileList.length >= 1) {
                this.$message.error('只能上传1个文件');
            }
        }
    },
    created() {
        this.headers.Comid = JSON.parse(sessionStorage.getItem('shenfen')).com_id;
        console.log(this.url);
    }
}
</script>

<style scoped lang="scss">
    .importCluesBox{
        padding: 30px;
        background-color: #fff;
        border-radius: 5px;
    }
    .title {
        height: 60px;
        color: #409eff;
        display: flex;
        align-items: center;
    }

    .title > p {
        margin-right: 10px;
        width: 5px;
        height: 18px;
        background-color: #409eff;
    }
    .upload-demo{
        margin-top: 20px;
    }
</style>